import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import flipUi from './modules/flipUi'
import transaction from './modules/transaction'
import countries from './modules/countries'
import adminUser from './modules/admin/adminUser'
import adminPayout from './modules/admin/adminPayout'
import adminPending from './modules/admin/adminPending'
import adminAsset from './modules/admin/adminAsset'
import adminConsignor from './modules/admin/adminConsignor'
import adminAssetType from './modules/admin/adminAssetType'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    flipUi,
    transaction,
    countries,
    adminUser,
    adminAsset,
    adminConsignor,
    adminAssetType,
    adminPayout,
    adminPending
  }
})
